/* eslint-disable */
import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { CaasService } from './services/caas/caas.service';
import { ConfirmationsPageContent } from './models/aem-graphql.model';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import '@vanguard/ocean-platform-window-events';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit{
  public constructor(
    private readonly titleService: Title,
    private readonly metaService: Meta,
    private readonly caasService: CaasService,
    private readonly router: Router
  ) {
    // Global router navigation tracking
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
    });

    // Override router navigate to track all programmatic navigation
    const originalNavigate = this.router.navigate.bind(this.router);
    this.router.navigate = (commands: any[], extras?: any) => {
      return originalNavigate(commands, extras);
    };
  }

  ngOnInit(){
    const content = this.caasService.getPageContent();
    if (content) {
      this.updateMetaTags(content);
    }
  }

  private updateMetaTags(content: ConfirmationsPageContent): void {
    this.titleService.setTitle(content.seoBrowserTitle);

    this.metaService.updateTag({ name: 'description', content: content.seoMetaDescription });

    // Build robots content: combine noindex and nofollow directives
    const robotsDirectives: string[] = [];
    if (content.enableNoindexRobots) {
      robotsDirectives.push('noindex');
    }
    if (content.enableNofollowRobots) {
      robotsDirectives.push('nofollow');
    }
    if (robotsDirectives.length > 0) {
      this.metaService.updateTag({ name: 'robots', content: robotsDirectives.join(', ') });
    } else {
      this.metaService.removeTag('name="robots"');
    }

    this.metaService.updateTag({ name: 'Keywords', content: content.keywordsMetaContent });
    this.metaService.updateTag({ name: 'Type of content', content: content.contentTypeMetaContent });
    this.metaService.updateTag({ name: 'Content format', content: content.contentFormatMetaContent });
    this.metaService.updateTag({ name: 'Topics', content: content.topicsMetaContent });

    if (content.aiModel) {
      this.metaService.updateTag({ name: 'AI model', content: content.aiModel });
    } else {
      this.metaService.updateTag({ name: 'AI model', content: '' });
    }
  }
}
